<script setup lang="ts">
import type { ButtonProps } from '@nuxt/ui'

const props = defineProps<{
  size?: ButtonProps['size']
}>()

const colorMode = useColorMode()

const isDark = computed(() => colorMode.value === 'dark')

function toggle() {
  colorMode.preference = isDark.value ? 'light' : 'dark'
}
</script>

<template>
  <ClientOnly>
    <UTooltip :text="isDark ? 'Light mode' : 'Dark mode'">
      <UButton
        :icon="isDark ? 'i-lucide-sun' : 'i-lucide-moon'"
        :size="props.size"
        color="neutral"
        variant="ghost"
        :aria-label="isDark ? 'Switch to light mode' : 'Switch to dark mode'"
        @click="toggle"
      />
    </UTooltip>
    <template #fallback>
      <div :class="props.size === 'xs' ? 'size-6' : 'size-8'" />
    </template>
  </ClientOnly>
</template>
